import { render, staticRenderFns } from "./userStats.vue?vue&type=template&id=b99c7554&scoped=true&"
import script from "./userStats.vue?vue&type=script&lang=js&"
export * from "./userStats.vue?vue&type=script&lang=js&"
import style0 from "./userStats.vue?vue&type=style&index=0&id=b99c7554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99c7554",
  null
  
)

export default component.exports